import type { MerchantApiClient } from "../../types.js";
import type {
  MerchantWidgetDiagnosticDto,
  StorefrontWidgetConfig,
  WidgetSettingsDto,
} from "./models.js";

interface DataEnvelope<T> {
  data: T;
  meta: { requestId: string };
}

export interface WidgetSettingsApi {
  getWidget(): Promise<WidgetSettingsDto>;
  getWidgetDiagnostics(): Promise<MerchantWidgetDiagnosticDto[]>;
  updateWidget(config: StorefrontWidgetConfig, idempotencyKey: string): Promise<WidgetSettingsDto>;
}

export function createWidgetSettingsApi(client: MerchantApiClient): WidgetSettingsApi {
  return {
    async getWidget() {
      return unwrap(await client.get<DataEnvelope<WidgetSettingsDto>>("/v1/api/widget"));
    },
    async getWidgetDiagnostics() {
      return unwrap(
        await client.get<DataEnvelope<MerchantWidgetDiagnosticDto[]>>("/v1/api/widget/diagnostics"),
      );
    },
    async updateWidget(config, idempotencyKey) {
      return unwrap(
        await client.put<DataEnvelope<WidgetSettingsDto>>(
          "/v1/api/widget",
          { config },
          { idempotencyKey },
        ),
      );
    },
  };
}

function unwrap<T>(envelope: DataEnvelope<T>): T {
  return envelope.data;
}
